import { Box, VStack, HStack, Text, useMediaQuery } from 'native-base';
import { MOBILE_VIEW_WIDTH } from '../../../../utils/screens';
import CustomModal from '../../../../components/modal';
import MobileModelSheet from '../../../../components/actionSheet';
import CustomButton from '../../../../components/button';
import { COLORS } from '../../../../utils/colors';
import { noPhotosUploadedSVG } from '../../../../utils/svg';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onProceed, 
  selectedHotelsCount, 
  isLoading = false 
}) => {
  const [MobileWindow] = useMediaQuery({ maxWidth: MOBILE_VIEW_WIDTH });

  const modalBody = () => (
    <VStack space={4} alignItems="center" p={4}>
      {noPhotosUploadedSVG}
        <Text
          fontSize="14px"
          color={COLORS.BLACK_COLOR}
          textAlign="center"
          lineHeight="20px"
        >
          This enquiry is subject to the availability of the hotel. 
          Are you sure you want to send the email enquiry for the selected hotels?
        </Text>
    </VStack>
  );

  const modalFooter = () => (
    <HStack
      justifyContent="flex-end"
      space={6}
      width="100%"
    >
      <CustomButton
        text="Cancel"
        onPress={onClose}
        isOutline
        bgColor={COLORS.BLACK_COLOR}
        textColor={COLORS.BLACK_COLOR}
        disabled={isLoading}
      />
      <CustomButton
        text="Proceed"
        onPress={onProceed}
        isLoading={isLoading}
      />
    </HStack>
  );

  return (
    <>
      {!MobileWindow ? (
        <CustomModal
          isOpen={isOpen}
          onClose={onClose}
          header="Send Email Enquiry"
          body={modalBody()}
          footer={modalFooter()}
          width="40%"
        />
      ) : (
        <MobileModelSheet
          isOpen={isOpen}
          onClose={onClose}
          header="Send Email Enquiry"
          body={modalBody()}
          footer={modalFooter()}
          maxH="50vh"
        />
      )}
    </>
  );
};

export default ConfirmationModal;
